import * as React from 'react';
import utils = egr.wcf.utils;
import { BaseComponent } from '../BaseComponent';

export interface BasePopupMenuTitleSetting {
    label: string;
    className?: string;
    callback?: () => void;
    link?: string;
}

export class BasePopupMenuHeader extends BaseComponent<BasePopupMenuTitleSetting, {}> {
    public render(): JSX.Element | null {
        if (utils.string.isNullOrEmpty(this.props.label)) {
            return null;
        }

        if (this.props.callback) {
            return (
                <div
                    style={{cursor: 'pointer'}}
                    className={'egr-select-option-header ' + (this.props.className ? this.props.className : '')}
                    onClick={this.props.callback}
                >
                    <span>{this.props.label}</span>
                </div>
            );
        }
        if (this.props.link) {
            return (
                <a
                    style={{cursor: 'pointer'}}
                    className={'egr-select-option-header ' + (this.props.className ? this.props.className : '')}
                    href={this.props.link}
                    target="_blank"
                >
                    {this.props.label}
                </a>
            );
        }
        return (
            <div
                className={'egr-select-option-header ' + (this.props.className ? this.props.className : '')}
            >
                <span>{this.props.label}</span>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/popupmenu/BasePopupMenuHeader.tsx